// Client-side second pass over a body Rails already sanitized (AnnouncementBodyRenderer),
// shared so the bar and the modal cannot drift on what they allow.
export const ANNOUNCEMENT_BODY_ALLOWED_TAGS = ['p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li', 'a', 'h3', 'h4']
export const ANNOUNCEMENT_BODY_ALLOWED_ATTR = ['href', 'target', 'rel']
export const ANNOUNCEMENT_BODY_SANITIZE_OPTIONS = { assumeServerSanitized: true }

// A CTA whose destination is a dialog opened in place, not a page to navigate to.
export const UPGRADE_NOW_TYPE = 'billing_modal'

// A modified click is a request for a new tab, and belongs to the browser.
export const isModifiedClick = (event) =>
  event.metaKey || event.ctrlKey || event.shiftKey || event.altKey

// The CTA as a URL, or null when it is not one we will follow. Backstop for rows written
// before the model validated CTAs; mirrors Announcement.safe_cta_url?.
export const ctaTarget = (url) => {
  if (!url) return null
  // The parser would resolve //evil.com against an https page into a valid https URL.
  if (url.startsWith('//')) return null

  try {
    const target = new URL(url, typeof window === 'undefined' ? 'https://app.easyllama.com' : window.location.href)

    return target.protocol === 'http:' || target.protocol === 'https:' ? target : null
  } catch {
    return null
  }
}

// The href to render, as authored, or null to drop the control. Not the resolved absolute
// form, which would show a different link from the one the author typed.
export const ctaHref = (url) => (ctaTarget(url) ? url : null)
